import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import * as _ from 'lodash';

import LifeEventsTable from './LifeEventsTable';
import LifeEventForm from './LifeEventForm';
import { deepEqual } from './../../utils';

import './styles.css';

const INITIAL_STATE = {
  events: [],
  inFormEvent: {},
};

class DriverLifeEvents extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.saveForm = this.saveForm.bind(this);
    this.clearInFormEvent = this.clearInFormEvent.bind(this);
    this.deleteEvent = this.deleteEvent.bind(this);
  }

  componentWillMount() {
    this.subscribeToLifeEvents();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !deepEqual(this.props, nextProps)
      || !deepEqual(this.state, nextState);
  }

  componentWillUnmount() {
    this.unsubscribeToLifeEvents();
  }

  subscribeToLifeEvents() {
    this.eventsRef = firebase.database()
      .ref(`/clients/${this.props.client}/driver/lifeEvents/${this.props.driver.$key}`);

    this.eventsListener = this.eventsRef.on('value', (eventsSnapshot) => {
      this.setState({
        events: _.orderBy(_.map(eventsSnapshot.val(), (event, id) => ({
          id,
          startedAt: Number(id),
          ...event,
        })), ['startedAt'], ['desc']),
      });
    });
  }

  unsubscribeToLifeEvents() {
    this.eventsRef.off('value', this.eventsListener);
  }

  saveForm(event) {
    const { client, uid, driver: { $key: driverId } } = this.props;
    const { startedAt, ...eventData } = event;
    firebase.database()
      .ref('/clients').child(client)
      .child('/driver/lifeEvents/')
      .child(driverId)
      .child(String(startedAt))
      .update({
        ...eventData,
        createdAt: firebase.database.ServerValue.TIMESTAMP,
        uid,
      });
    this.clearInFormEvent();
  }

  clearInFormEvent() {
    this.setState({
      inFormEvent: {},
    });
  }

  deleteEvent(eventId) {
    const { client, driver: { $key: driverId } } = this.props;
    firebase.database()
      .ref('/clients').child(client)
      .child('/driver/lifeEvents/')
      .child(driverId)
      .child(eventId)
      .remove();
  }

  render() {
    return (
      <div>
        <LifeEventForm
          event={this.state.inFormEvent}
          lastEvent={this.state.events[0]}
          onSave={this.saveForm}
          onCancel={this.clearInFormEvent}
        />
        <LifeEventsTable
          events={this.state.events}
          onDelete={this.deleteEvent}
        />
      </div>
    );
  }
}

DriverLifeEvents.propTypes = {
  driver: PropTypes.object.isRequired,
  client: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
};

const mapStateToProps = store => ({
  client: store.authState.currentUser.client,
  uid: store.authState.currentUser.uid,
});

export default connect(mapStateToProps, null)(DriverLifeEvents);



// WEBPACK FOOTER //
// ./src/Driver/DriverLifeEventsPopup/DriverLifeEvents.js